var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "batchDisbursementModal" },
    [
      _c(
        "el-dialog",
        {
          staticClass: "diglog-card",
          attrs: {
            visible: _vm.dialogVisible,
            title: _vm.$t("payment_links.new_link"),
            "close-on-click-modal": false,
            width: "739px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "header-line" }),
          _c("div", { staticClass: "section-title" }, [
            _vm._v(
              " " + _vm._s(_vm.$t("payment_links.batch_link_details")) + " "
            ),
          ]),
          _c("div", { staticClass: "section-tip" }, [
            _vm._v(" " + _vm._s(_vm.$t("payment_links.tip_2")) + " "),
          ]),
          _c("div", { staticClass: "step" }, [
            _c("div", { staticClass: "step-item" }, [
              _c("div", { staticClass: "step-item-left" }, [
                _c("div", { staticClass: "section-step-title" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t("send_pagements.excel_worksheet_template_excel")
                    )
                  ),
                ]),
                _c("div", { staticClass: "section-tip" }, [
                  _vm._v(" " + _vm._s(_vm.$t("tips.latest_template")) + " "),
                ]),
              ]),
              _c(
                "div",
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "btn-download",
                      attrs: {
                        type: "primary",
                        size: "small",
                        icon: "el-icon-download",
                      },
                      on: { click: _vm.onClickDownloadBtn },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("customerService.download_template"))
                      ),
                    ]
                  ),
                  _c("div", { staticStyle: { "margin-top": "10px" } }, [
                    _vm._v(
                      _vm._s(_vm.$t("tips.please_upload_latest_template"))
                    ),
                  ]),
                ],
                1
              ),
            ]),
            _c("div", {
              staticClass: "line-bottom-1px",
              staticStyle: { "margin-bottom": "32px" },
            }),
            _c("div", { staticClass: "step-item" }, [
              _c(
                "div",
                {
                  staticClass: "step-item-left",
                  staticStyle: { "margin-top": "32px" },
                },
                [
                  _c("div", { staticClass: "section-step-title" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("tips.upload_filled_excel_worksheet_template")
                      )
                    ),
                  ]),
                  _c("div", { staticClass: "section-tip" }, [
                    _vm._v(" " + _vm._s(_vm.$t("payment_links.tip_3"))),
                  ]),
                ]
              ),
              _c(
                "div",
                [
                  _c(
                    "PaymentUploadExcelFile",
                    _vm._g(
                      {
                        attrs: { "reference-batch-no": _vm.reference_batch_no },
                        on: { templateFileSuccess: _vm.templateFileSuccess },
                      },
                      _vm.$listeners
                    )
                  ),
                ],
                1
              ),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }